import {apiback} from '../../../../../config';
import {Sync} from 'MWC';

export default {
    isSuccess: false,
    isGlobalError: false,
    isDisabled: false,
    documentUrl: '',
    sendForm: async function(document) {
        this.isDisabled = true;
        const Engine = Sync.getEngine('xhr'),
            url = apiback('API_CHECKDOCUMENT'),
            // url = 'http://a-bank-dev9.ab.loc/api/v1/document/check',
            xhr = new Engine({
                url: `${url}?document=${document}`,
                type: 'GET',
                dataType: 'json',
                cache: false
            });

        try {
            const response = await xhr.get();
            this.settingPage(response);
        } catch (error) {
            this.settingPage(error);
            return error;
        } finally {
            this.isDisabled = false;
        }
    },
    settingPage: function(response) {
        this.isGlobalError = !(this.isSuccess = !!response.data);
        this.documentUrl = response.data && response.data.url ? response.data.url : '';
    }
};
